export default __webpack_public_path__ + "static/media/the-nights.6f40a0af.png";